import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from "./state.js";
import { getStorage } from "./helper";

import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Form from 'react-bootstrap/Form';
import {
  Routes,
  Route,
  BrowserRouter,
  Link,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import './styles.css';
import Layout from "./layout";
import Login from "./routes/login/index.js";

import Home from "./routes/home";
import Listings from "./routes/listings";
import Settings from "./routes/settings";
import Send from "./routes/send";
import ChangePassword from "./routes/change-password";
import Roles from "./routes/roles";
import Users from "./routes/users";
import Colors from "./routes/colors";
import Category from "./routes/category";
import AddNew from "./routes/add_new";
import EntryForm from "./routes/form";


import AddPhoneBook from "./modals/addphonebook";
import AddContact from "./modals/addcontact";
import ImportContacts from "./modals/import";
import Templates from "./modals/templates";
import Role from "./modals/role.js";
import Color from "./modals/color.js";
import PrintContacts from "./modals/print.js";
import Listing from "./modals/listing.js";
import Filter from "./modals/filter.js";

import NiceModal, { ModalDef, useModal } from '@ebay/nice-modal-react';

if (getStorage('token')) {
  useStore.setState({ auth: 1 });
  //setAuth('1');

}
function AuthRoute({ children }) {
  const auth = useStore((state) => state.auth)
  let location = useLocation();

  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}





export default function App() {


  const location = useLocation();
  useEffect(() => {


  }, [location]);
  return (
    <>
      <Routes>

        <Route path="/" element={<Layout />}  >
          <Route path="/" element={<Home />} />
          <Route path="listings" element={<Listings />} />
          <Route path="category/*" element={<Category />} />


          <Route path="add-your-business" element={<AddNew />} />
          <Route path="form/:token" element={<EntryForm />} />

        </Route>
        <Route path="*" element={<NoMatch />} />
        <Route path="/login" element={<Login />} />


      </Routes>
      <ModalDef id="addphonebook" component={AddPhoneBook} />
      <ModalDef id="addcontact" component={AddContact} />
      <ModalDef id="importcontacts" component={ImportContacts} />
      <ModalDef id="templates" component={Templates} />
      <ModalDef id="role" component={Role} />
      <ModalDef id="print" component={PrintContacts} />
      <ModalDef id="listing" component={Listing} />
      <ModalDef id="color" component={Color} />
      <ModalDef id="filter" component={Filter} />

    </>
  );
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
